// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import Layout from './components/layout/Layout';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ReferralRedirectPage from './pages/ReferralRedirectPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import RequestPasswordResetPage from './pages/RequestPasswordResetPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import StatsPage from './pages/StatsPage';
import StrategiesHubPage from './pages/StrategiesHubPage';
import StrategyDetailPage from './pages/StrategyDetailPage';
import AccountsPage from './pages/AccountsPage';
import SettingsPage from './pages/SettingsPage';
import AutoTradingPage from './pages/AutoTradingPage';
import AdminControlPage from './pages/AdminControlPage';
import PairAnalysisPage from './pages/PairAnalysisPage';
import PartnerProgramPage from './pages/PartnerProgramPage';
import FaqRedirectPage from './pages/FaqRedirectPage';
import './i18n';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-white">Loading...</div>;
  return user ? children : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
};

const ProtectedLayout = () => {
  return (
    <PrivateRoute>
      <Layout>
        <Outlet />
      </Layout>
    </PrivateRoute>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/invite" element={<ReferralRedirectPage />} />
          <Route path="/invite/:code" element={<ReferralRedirectPage />} />
          <Route path="/ref/:code" element={<ReferralRedirectPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/request-password-reset" element={<RequestPasswordResetPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />

          <Route element={<ProtectedLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/pair-analysis" element={<PairAnalysisPage />} />
            <Route path="/stats" element={<StatsPage />} />
            <Route path="/strategies" element={<StrategiesHubPage />} />
            <Route path="/strategies/:strategyId" element={<StrategyDetailPage />} />
            <Route path="/accounts" element={<AccountsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/auto-trading" element={<AutoTradingPage />} />
            <Route path="/admincontrol" element={<AdminControlPage />} />
            <Route path="/faq" element={<FaqRedirectPage />} />

            {/* НОВЫЙ РОУТ ДЛЯ ГЕНЕРАЦИИ КАРТИНКИ */}
            <Route path="/partner-program" element={<PartnerProgramPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
